import Flickity from 'flickity';
import { videoLoaded } from '../../src/js/events';

import MobileCarousel from '../../src/js/mobile-carousel';

export default class SocialProof {
  constructor() {
    this.$el = document.querySelector('.js-social-proof-animation');
    if (!this.$el) return;

    this.progress = 0;
    this.$steps = document.querySelectorAll('.js-social-proof-step');
    this.$progress = document.querySelector('.js-social-proof-animation-progress');
    this.$mobileLabels = document.querySelectorAll('.js-social-proof-mobile-label');

    window.addEventListener(videoLoaded, (e) => {
      const $parent = e.detail.el.parentElement;

      if ($parent.classList.contains('js-social-proof-animation')) {
        this.$video = $parent.querySelector('video');

        // Assume "video" is the video node
        const interval = setInterval(() => {
          if (this.$video.readyState > 0) {
            this.watcher = requestAnimationFrame(() => this.updateProgress());
            clearInterval(interval);
          }
        }, 200);
      }
    });
  }

  updateProgress() {
    const progress = this.$video.currentTime / this.$video.duration * 100;
    this.$progress.style.width = `${progress}%`;

    this.$mobileLabels.forEach(($label) => {
      $label.classList.remove('is-active');
    });

    if (progress < 1) {
      this.$steps.forEach(($step) => {
        $step.classList.remove('is-active');
      });
    }

    if (progress > 0 && progress < 25) {
      this.$steps[0].classList.add('is-active');
      this.$mobileLabels[0].classList.add('is-active');
    }

    if (progress > 25 && progress < 55) {
      this.$steps[1].classList.add('is-active');
      this.$mobileLabels[1].classList.add('is-active');
    }

    if (progress > 55 && progress < 85) {
      this.$steps[2].classList.add('is-active');
      this.$mobileLabels[2].classList.add('is-active');
    }

    if (progress > 85) {
      this.$steps[3].classList.add('is-active');
      this.$mobileLabels[3].classList.add('is-active');
    }

    this.watcher = requestAnimationFrame(() => this.updateProgress());
  }
}
